import React from 'react';
import './Loader.css';

const Loader = ({ loading, message = 'Cargando...' }) => {
    if (!loading) return null;

    return (
        <div className="premium-loader-overlay">
            <div className="premium-loader-content">
                <div className="loader-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div className="loader-text">
                    <span className="loader-message">{message}</span>
                    <span className="loader-dots"></span>
                </div>
            </div>
        </div>
    );
};

export default Loader;
